export enum SelectedAge{
    none,
    birth,
    thirtyFive,
    sixtyFive
  }